var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpressCourier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2375_105086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.707 9.80157L7.95705 19.1766C7.86432 19.2755 7.74192 19.3416 7.60833 19.3649C7.47473 19.3882 7.33718 19.3674 7.21644 19.3057C7.0957 19.244 6.99831 19.1446 6.93898 19.0227C6.87964 18.9007 6.86158 18.7628 6.88751 18.6297L8.03283 12.9008L3.53048 11.2102C3.43379 11.174 3.34756 11.1144 3.2795 11.0368C3.21144 10.9592 3.16367 10.8659 3.14046 10.7653C3.11724 10.6647 3.11931 10.5599 3.14647 10.4603C3.17363 10.3607 3.22504 10.2694 3.29611 10.1945L12.0461 0.819538C12.1388 0.720581 12.2612 0.654468 12.3948 0.631176C12.5284 0.607884 12.666 0.628675 12.7867 0.690414C12.9075 0.752152 13.0048 0.851488 13.0642 0.97343C13.1235 1.09537 13.1416 1.2333 13.1156 1.36641L11.9672 7.10157L16.4695 8.78985C16.5655 8.82626 16.6511 8.88576 16.7186 8.96307C16.7861 9.04039 16.8336 9.13315 16.8567 9.23316C16.8799 9.33317 16.8781 9.43734 16.8514 9.53648C16.8248 9.63562 16.7741 9.72666 16.7039 9.80157H16.707Z",
    fill: "#FFCE73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2375_105086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressCourier);
export default __webpack_public_path__ + "static/media/express_courier.c86d396eb3b3fff2f73ef15a8952f751.svg";
export { ForwardRef as ReactComponent };